import { useEffect } from "react";
import { BASE_PAGE_NAME } from "../model/constants";

const usePageTitile = (title: string | undefined) => {
  useEffect(() => {
    document.title = title === undefined ? BASE_PAGE_NAME : title;
  }, [title]);
};

export default usePageTitile;